import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import type { PageMenuItem } from '@dhl-ui/page'
import { DashboardIcon, MoreHorizontalIcon, ParcelMIcon, RoutesIcon, TruckIcon } from '@dhl-ui/icons'
import { useRoleParamFromUrl } from '@dhl/tracktrace'

import { links } from '~/links.js'

export const useMenuItems = (): PageMenuItem[] => {
  const { t } = useTranslation()
  const location = useLocation()
  const role = useRoleParamFromUrl()
  const isShipper = role === 'consumer-shipper'
  const isTrackTracelink = location.pathname.includes(links.trackTraceLinks())
  const isInterventionLink = location.pathname.includes(links.consolidatedIntervention())

  const menuItems: PageMenuItem[] = [
    {
      key: 'dashboard',
      label: t('portal.components.bottomNavigation.dashboardButton'),
      icon: <DashboardIcon />,
      link: links.dashboardLink(),
      isActive: location.pathname.includes(links.dashboardLink()),
    },
    {
      key: 'receive',
      label: t('portal.components.bottomNavigation.receiveButton'),
      icon: <TruckIcon />,
      link: links.incomingPiecesLink(),
      isActive:
        location.pathname.includes(links.incomingPiecesLink()) ||
        (isTrackTracelink && !isShipper) ||
        isInterventionLink,
    },
    {
      key: 'send',
      label: t('portal.components.bottomNavigation.sendButton'),
      icon: <ParcelMIcon />,
      link: links.outgoingPiecesLink(),
      isActive:
        location.pathname.includes(links.outgoingPiecesLink()) ||
        (isTrackTracelink && isShipper) ||
        location.pathname.startsWith(links.c2cLink()),
    },
    {
      key: 'locator',
      label: t('portal.components.bottomNavigation.locatorButton'),
      icon: <RoutesIcon />,
      link: links.locatorLink(),
      isActive: location.pathname.includes(links.locatorLink()),
    },
    {
      key: 'more',
      label: t('portal.components.bottomNavigation.moreButton'),
      icon: <MoreHorizontalIcon />,
      link: links.moreOverviewLink(),
      isActive: location.pathname.includes(links.moreOverviewLink()),
    },
  ].filter(Boolean) satisfies PageMenuItem[]

  return menuItems
}
